import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useSessionsForMonth } from '@/hooks/use-coach-data';
import { SessionCalendar } from '@/components/shared/session-calendar';
import { SessionFormModal } from '@/components/coach/session-form-modal';

export default function CoachCalendarPage() {
  const navigate = useNavigate();
  const [calendarMonth, setCalendarMonth] = useState(() => new Date());
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [defaultDate, setDefaultDate] = useState(() => {
    const now = new Date();
    const y = now.getFullYear();
    const m = String(now.getMonth() + 1).padStart(2, '0');
    const d = String(now.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  });

  const { data: monthData } = useSessionsForMonth(
    calendarMonth.getFullYear(),
    calendarMonth.getMonth()
  );

  const handleSessionClick = (session: { id: string }) => {
    navigate(`/coach/sessions/${session.id}/attendance`);
  };

  const handleMonthChange = (year: number, month: number) => {
    setCalendarMonth(new Date(year, month, 1));
    // Update default date to first of the new month
    setDefaultDate(`${year}-${String(month + 1).padStart(2, '0')}-01`);
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold text-foreground">Calendar</h1>
        <Button size="sm" className="flex items-center gap-2" onClick={() => setShowCreateModal(true)}>
          <Plus className="w-4 h-4" />
          Add Session
        </Button>
      </div>

      <SessionCalendar
        sessions={monthData?.sessions ?? []}
        isLoading={!monthData}
        onSessionClick={handleSessionClick}
        onMonthChange={handleMonthChange}
        variant="coach"
      />

      <SessionFormModal
        open={showCreateModal}
        onOpenChange={setShowCreateModal}
        defaultDate={defaultDate}
      />
    </div>
  );
}
